import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import feather from 'feather-icons';
import { SERVER_BASE_URL } from '../../config/app.config';
import { useLanguage } from '../../context/LanguageContext';
import Alert from '../Alert';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const AuthForm = ({
    setEmail,
    setPassword,
    error,
    IsInvalid,
    handleSubmit,
}) => {
    const { t } = useLanguage();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        feather.replace();
    }, [showPassword]);

    const openGoogleLogin = (event) => {
        event.preventDefault();
        const width = 500;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        window.open(
            `${SERVER_BASE_URL}/auth/google/login`,
            'GoogleLogin',
            `width=${width},height=${height},top=${top},left=${left}`
        );
    };

    const openFacebookLogin = (event) => {
        event.preventDefault();
        const width = 500;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        window.open(
            `${SERVER_BASE_URL}/auth/facebook/login`,
            'Facebook Login',
            `width=${width},height=${height},top=${top},left=${left}`
        );
    };

    const togglePasswordVisibility = (e) => {
        e.preventDefault();
        setShowPassword(!showPassword);
    };

    return (
        <form onSubmit={handleSubmit} className="auth-form" target="_blank">
            <div className="custom-container">
                {/* Social Login Buttons */}
                <button type="button" onClick={openGoogleLogin} className="btn gray-btn width-100">
                    <img
                        className="img-fluid google"
                        src={'assets/images/svg/google.svg'}
                        alt="google"
                    />
                    {t('continueWithGoogle')}
                </button>
                <button
                    type="button"
                    onClick={openFacebookLogin}
                    className="btn gray-btn mt-3 width-100"
                >
                    <img
                        className="img-fluid google"
                        src={'assets/images/svg/facebook.svg'}
                        alt="facebook"
                    />
                    {t('continueWithFacebook')}
                </button>

                <div className="division">
                    <span>{t('or')}</span>
                </div>

                {/* Email Form Fields */}
                <div className="form-group">
                    <label htmlFor="email" className="form-label">
                        {t('emailId')}
                    </label>
                    <div className="form-input">
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder={t('enterEmail')}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            required
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="password" className="form-label">
                        {t('password')}
                    </label>
                    <div className="form-input password-input-wrapper">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-control"
                            id="password"
                            placeholder={t('enterPassword')}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                        <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="password-toggle-btn"
                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                        >
                            {showPassword ? (
                                <FiEyeOff className="eye-icon-text-field" />
                            ) : (
                                <FiEye className="eye-icon-text-field" />
                            )}
                        </button>
                    </div>
                </div>

                <div className="remember-option">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="flexCheckDefault" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            {t('rememberMe')}
                        </label>
                    </div>
                    <Link className="forgot" to="/forgot-password">
                        {t('forgotPin')}
                    </Link>
                </div>

                {error && <Alert alert={'danger'}> {error} </Alert>}

                <Button type="submit" disabled={IsInvalid} className="btn theme-btn w-100">
                    {t('signIn')}
                </Button>

                <h4 className="signup">
                    {t('dontHaveAccount')} <Link to="/register"> {t('signUp')}</Link>
                </h4>
            </div>
        </form>
    );
};

export default AuthForm;
